import React, { useContext, useEffect, useState } from "react";
import HelpButton from "./help-button";
import Plane from "../components/jet-icon";
import StartOverButton from "./start-over-button";
import Ownership from "../components/ownership-icon";
import Plan from "../components/plan-icon";
import ArrowBottom from "../components/arrow-botom-icon";
import Ellipse from "../components/ellipse-icon";
import Logo from "./logo";
import GettingStartedContext from "../utils/GettingStartedContext";
import GLightbox from "glightbox";

const ResultSummarySection = () => {
    const { data, getProperty, isFr, lang, langString, scrollTo } = useContext(
        GettingStartedContext
    );

    // useEffect(() => {
    //   //TODO:
    //   // $('.js-open-iframe-popup').magnificPopup({type:'iframe'});
    // }, []);

    // const showPopup = (e) => {
    //   let link = getProperty(data.BestPlane, 'VrURL');
    //   if (link) {
    //     // TODO
    //     // $('.js-open-iframe-popup').magnificPopup({
    //     //   type: 'iframe',
    //     //   iframe: {
    //     //     patterns: {
    //     //       anyUrl: {
    //     //         id(url) {
    //     //
    //     //           return url;
    //     //
    //     //         },
    //     //         src: '%id%',
    //     //       },
    //     //     },
    //     //   },
    //     // });
    //   }
    //   e.preventDefault();
    // }

    useEffect(() => {
        /*const lightbox = GLightbox({
            selector: ".js-open-iframe-popup",
            slideExtraClasses: "custom-lightbox-slide",
            touchNavigation: false,
            width: "85vw",
            height: "90vh",
        });

        return () => {
            lightbox.destroy();
        };*/
    }, []);

    const showPopup = (e) => {
        //const link = getProperty(data.BestPlane, "VrURL");
        const link = e.target.getAttribute('href');
        
        if (link) {
            let lightbox = GLightbox({
                selector: ".video-tour",
                touchNavigation: false,
                loop: false,
                autoplayVideos: true,
                onClose: function(e){
                    lightbox.destroy();
                }
            });
    
            lightbox.open();
        }
        e.preventDefault();
    };

    let virtualTourBTNClass =
        "gsa__result-360 button video-tour secondary btn-pill";
    if (isFr()) {
        virtualTourBTNClass =
            "gsa__result-360 gsa__result-360--fr video-tour button secondary btn-pill";
    }

    const options = data.Options;

    return (
        <div className="gsa__results-top">
            <div
                className="gsa__bg"
                style={{
                    backgroundImage:
                        "url(" +
                        (data.ResultPageImageURL
                            ? data.ResultPageImageURL
                            : data.ImageURL) +
                        ")",
                }}
            />
            <div className="gsa__header">
                <div className="grid-x">
                    <div className="cell col-6">
                        <Logo url={data.BaseURL} locale={lang} />
                    </div>
                    <div className="cell col-6 gsa__header-buttons">
                        <ul>
                            <HelpButton />
                            <StartOverButton
                                text={data.ExitText}
                                startOver={false}
                                exit={true}
                            />
                        </ul>
                    </div>
                </div>
            </div>

            <div className="gsa__content gsa__results-content">
                <div className="grid-container grid-container--gsa">
                    <div className="grid-x">
                        {/* <div className="cell small-12 medium-5"> */}
                        <div className="cell small-12 medium-10 xlmedium-5">
                            <h1>{langString("GREAT")}</h1>
                            <p>{langString("AIRSPRINT_PACKAGE_TEXT")}</p>
                            {/* <div className="gsa__result-plane hide-for-medium">
                                <img src={options.PlaneImageURL} />
                                {options.BestPlane &&
                                    options.BestPlane.VrURL && (
                                        <>
                                            <a
                                                href={options.BestPlane.VrURL}
                                                className="js-open-iframe-popup gsa__result-360"
                                                onClick={(e) => showPopup(e)}
                                            >
                                                <div>
                                                    {langString("VIRTUAL_TOUR")}
                                                </div>
                                            </a>
                                        </>
                                    )}
                            </div> */}
                            <ul className="gsa__result-options">
                                <li>
                                    <Plane />
                                    <div className="gsa__result-text">
                                        <span>{langString("YOUR_JET")}</span>
                                        <h3>
                                            {getProperty(
                                                options.BestPlane,
                                                "Title"
                                            )}
                                        </h3>
                                    </div>
                                </li>
                                <li>
                                    <Ownership />
                                    <div className="gsa__result-text">
                                        <span>
                                            {langString("YOUR_OWNERSHIP")}
                                        </span>
                                        <h3>
                                            {getProperty(
                                                options.BestOwnership,
                                                "Title"
                                            )}
                                        </h3>
                                    </div>
                                </li>
                                <li>
                                    <Plan />
                                    <div className="gsa__result-text">
                                        <span>{langString("YOUR_PLAN")}</span>
                                        <h3>
                                            {getProperty(
                                                options.BestPlan,
                                                "Title"
                                            )}
                                            <span className="suffix">
                                                (
                                                {getProperty(
                                                    options.BestPlan,
                                                    "HoursText"
                                                )}
                                                )
                                            </span>
                                        </h3>
                                    </div>
                                </li>
                            </ul>
                            <div className="gsa__result--actions">
                                <button
                                    onClick={() => scrollTo("details-section")}
                                    className="button secondary hollow"
                                >
                                    {langString("VIEW_DETAILS")}
                                    <ArrowBottom />
                                </button>
                                <button
                                    onClick={() => scrollTo("costs-section")}
                                    className="button secondary"
                                >
                                    {langString("SEE_PRICING")}
                                    <ArrowBottom />
                                </button>
                            </div>
                        </div>
                        {/* <div className="cell small-12 medium-6 medium-offset-1 hide-for-small show-for-medium"> */}
                        <div className="cell small-12 xlmedium-7">
                            <div className="gsa__result-plane">
                                <img src={options.PlaneImageURL} />
                                <div className="gsa__result-ellipse-container">
                                    <Ellipse />
                                    {options.BestPlane &&
                                        options.BestPlane.VrURL && (
                                            <>
                                                <a
                                                    href={
                                                        options.BestPlane.VrURL
                                                    }
                                                    className={
                                                        virtualTourBTNClass
                                                    }
                                                    onClick={(e) =>
                                                        showPopup(e)
                                                    }
                                                >
                                                    {/* <div> */}
                                                    {langString("VIRTUAL_TOUR")}
                                                    {/* </div> */}
                                                </a>
                                            </>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResultSummarySection;
